var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.ulList),function(item,i){return _c('ul',{key:i,staticClass:"list-disc"},[_c('li',[_vm._v(" "+_vm._s(item.li)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }